import { colors } from '@chegg-ui/theme'
import auFlag from '@src/assets/images/au-flag.svg'
import caFlag from '@src/assets/images/ca-flag.svg'
import ukFlag from '@src/assets/images/uk-flag.svg'
import usFlag from '@src/assets/images/us-flag.svg'
import { GRAMMAR } from '@src/components/Cards/constants'
import { isDemoSelector } from '@src/state/router/selectors'
import { EN_AU, EN_CA, EN_GB, EN_US, Locales } from '@src/state/session/types'
import { RootState } from '@src/state/types'
import { switchLocale } from '@src/state/workspace/actions'
import { selectCurrentCheckCategory } from '@src/state/workspace/selectors'
import {
  LOCALE_EN_AUS,
  LOCALE_EN_CA,
  LOCALE_EN_GB,
  LOCALE_EN_US,
  LOCALE_SWITCHER,
} from '@src/utils/dataTestIds'
import { getCurrentLocale, setLocaleToLocalStorage } from '@src/utils/locale'
import * as React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Dispatch } from 'redux'
import { getCheckCategoryPath } from '../NavTabs/utils'
import {
  FlagIcon,
  Heading,
  LocaleButton,
  LocaleText,
  OuterContainer,
  StyledCheckmarkIcon,
} from './styles'
import {
  LocaleMap,
  LocaleProps,
  LocaleSwitcherDispatchProps,
  LocaleSwitcherOwnProps,
  LocaleSwitcherProps,
  LocaleSwitcherStateProps,
} from './types'

const localeMap: LocaleMap = {
  [EN_US]: usFlag,
  [EN_GB]: ukFlag,
  [EN_AU]: auFlag,
  [EN_CA]: caFlag,
}

const displayNameMap = {
  [EN_US]: 'U.S. English',
  [EN_GB]: 'U.K. English',
  [EN_AU]: 'AU. English',
  [EN_CA]: 'CA. English',
}

const altTextmap = {
  [EN_US]: 'U.S',
  [EN_GB]: 'U.K.',
  [EN_AU]: 'AU.',
  [EN_CA]: 'CA.',
}

function getDataTestIdForLocale(locale: Locales) {
  switch (locale) {
    case EN_GB:
      return LOCALE_EN_GB
    case EN_CA:
      return LOCALE_EN_CA
    case EN_AU:
      return LOCALE_EN_AUS
    default:
      return LOCALE_EN_US
  }
}

const Locale: React.FunctionComponent<LocaleProps> = ({
  name,
  displayName,
  selected,
  switchLocale,
  hide,
  checksRunning,
  currentCheckCategory,
  history,
  match,
  isDemo,
}) => (
  <LocaleButton
    type="button"
    data-test={getDataTestIdForLocale(name)}
    onClick={() => {
      setLocaleToLocalStorage(name)
      if (hide) {
        hide()
      }
      if (currentCheckCategory !== GRAMMAR) {
        history.push(
          getCheckCategoryPath({
            paperId: match.params.id,
            checkCategory: GRAMMAR,
            isDemo,
          })
        )
      }
      switchLocale(name)
    }}
    disabled={checksRunning}
  >
    <FlagIcon alt={`${altTextmap[name]} national flag`} src={localeMap[name]} />
    <LocaleText>{displayName}</LocaleText>
    {selected && (
      <StyledCheckmarkIcon color={colors.teal} size="medium" aria-label="selected" />
    )}
  </LocaleButton>
)

const LocaleSwitcher: React.FunctionComponent<LocaleSwitcherProps> = props => {
  const [currentLocale, setLocale] = React.useState<Locales>()

  React.useEffect(() => {
    setLocale(getCurrentLocale())
  })

  return (
    <OuterContainer data-test={LOCALE_SWITCHER}>
      <Heading id="check-paper-using">Check paper using:</Heading>
      <div role="group" aria-labelledby="check-paper-using">
        <Locale
          {...props}
          name={EN_US}
          displayName={displayNameMap[EN_US]}
          selected={currentLocale === EN_US}
        />
        <Locale
          {...props}
          name={EN_GB}
          displayName={displayNameMap[EN_GB]}
          selected={currentLocale === EN_GB}
        />
        <Locale
          {...props}
          name={EN_CA}
          displayName={displayNameMap[EN_CA]}
          selected={currentLocale === EN_CA}
        />
        <Locale
          {...props}
          name={EN_AU}
          displayName={displayNameMap[EN_AU]}
          selected={currentLocale === EN_AU}
        />
      </div>
    </OuterContainer>
  )
}

const mapStateToProps = (state: RootState) => ({
  currentCheckCategory: selectCurrentCheckCategory(state),
  isDemo: isDemoSelector(state),
})
const mapDispatchToProps = (dispatch: Dispatch) => ({
  switchLocale: (type: Locales) => {
    dispatch(switchLocale({ type }))
  },
})

export default withRouter(
  connect<LocaleSwitcherStateProps, LocaleSwitcherDispatchProps, LocaleSwitcherOwnProps>(
    mapStateToProps,
    mapDispatchToProps
  )(LocaleSwitcher)
)



// WEBPACK FOOTER //
// ./src/layouts/shared/MoreActions/LocaleSwitcher.tsx